import { BodyCopy } from '../BodyCopy';
import DisclaimerText from '../DisclaimerText/DisclaimerText';
import Headline from '../Headline/Headline';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import { Subheadline } from '../Subheadline';
import { useOfferDetailsModalStore } from './OfferDetailsModal.store';

export type OfferDetailsModalProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  offerData: any;
  formattedEndDate: string;
  visible: boolean;
};

const OfferDetailsModal = (props: OfferDetailsModalProps) => {
  const { isModalOpen, setIsModalOpen } = useOfferDetailsModalStore();

  const handleCloseModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  return (
    <>
      {isModalOpen && props.visible && (
        <ModalWrapper
          isModalOpen={isModalOpen}
          handleClose={handleCloseModal}
          size="large"
          closeIconClasses="mt-xs mb-xxxs mr-s text-black"
        >
          <div className="z-[2] -mb-s flex flex-col items-center justify-evenly gap-y-s overflow-x-scroll bg-white px-m py-s !text-black">
            <Headline
              classes="text-m font-medium text-center"
              fields={{
                headlineText: {
                  value:
                    props.offerData?.headlineText?.value || props.offerData?.data?.headlineText,
                },
              }}
            />
            <BodyCopy
              classes="!text-body"
              refer={''}
              fields={{
                body: {
                  value:
                    props.offerData?.subHeadlineText?.value ||
                    props.offerData?.data?.subHeadlineText,
                },
              }}
            />
            <Subheadline
              classes="text-body !font-serif"
              fields={{
                subheadlineText: {
                  value: `Offer ends ${
                    props.offerData?.data?.offerEndDate || props.formattedEndDate
                  }`,
                },
              }}
            />
            <Subheadline
              classes="text-small !font-serif font-regular"
              fields={{
                subheadlineText: {
                  value:
                    props.offerData?.offerDetails?.value || props.offerData?.data?.offerDetails,
                },
              }}
            />
            <DisclaimerText
              fields={{
                value:
                  props.offerData?.legalDisclaimer?.value || props.offerData?.data?.legalDisclaimer,
              }}
              disclaimerClasses="!text-legal !leading-[16px]"
            />
          </div>
        </ModalWrapper>
      )}
    </>
  );
};

export default OfferDetailsModal;
